export default function(caloriesArr) {
  return {
    type: "SET_CALORIES_ARRAY",
    caloriesArr
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosMealArray/setCaloriesArr.js